import { useEffect, useRef, useState } from "react";
import "./FAQ.css";

function FAQItem({ q, a, isOpen, onToggle, delay = "0ms" }) {
  const bodyRef = useRef(null);
  const [h, setH] = useState(0);

  useEffect(() => {
    const node = bodyRef.current;
    if (!node) return;

    if (isOpen) {
      const nextH = node.scrollHeight || 0;
      setH(nextH);
    } else {
      setH(0);
    }
  }, [isOpen]);

  useEffect(() => {
    const node = bodyRef.current;
    if (!node) return;

    const onResize = () => {
      if (isOpen) setH(node.scrollHeight || 0);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [isOpen]);

  return (
    <button
      className={`faq__item card reveal ${isOpen ? "is-open" : ""}`}
      onClick={onToggle}
      aria-expanded={isOpen}
      style={{ "--d": delay }}
      type="button"
    >
      <div className="faq__q">
        <span>{q}</span>
        <span className="faq__plus" aria-hidden="true">
          <span className="faq__plusIcon">{isOpen ? "–" : "+"}</span>
        </span>
      </div>

      <div className="faq__panel" style={{ height: `${h}px` }}>
        <div className="faq__panelInner" ref={bodyRef}>
          <div className="faq__a">{a}</div>
        </div>
      </div>
    </button>
  );
}

export default function FAQ() {
  const sectionRef = useRef(null);

  // ✅ Only 5 important FAQs
  const faqs = [
    {
      q: "What services does your Social Media Marketing Agency in Sri Lanka offer?",
      a: "We offer social media management, content creation, reels, Meta ads, strategy, and monthly reporting.",
    },
    {
      q: "How can a Digital Marketing Agency help my business grow online?",
      a: "By improving visibility, generating leads, running ads, creating content, and improving conversions.",
    },
    {
      q: "Do you handle social media advertising campaigns?",
      a: "Yes. We plan, create, run, and optimize Meta/TikTok campaigns based on your goals and budget.",
    },
    {
      q: "How do you measure the success of social media campaigns?",
      a: "We track reach, clicks, leads, cost per result, conversions, engagement, and ROI with monthly reports.",
    },
    {
      q: "How much does it cost to hire a digital marketing agency?",
      a: "It depends on your goals and scope. We provide a custom proposal based on your budget and requirements.",
    },
  ];

  const [open, setOpen] = useState(0);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;

    const raf = requestAnimationFrame(() => el.classList.add("is-mounted"));

    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add("is-visible");
          io.disconnect();
        }
      },
      { threshold: 0.22 }
    );
    io.observe(el);

    return () => {
      cancelAnimationFrame(raf);
      io.disconnect();
    };
  }, []);

  return (
    <section className="section faqSection" ref={sectionRef}>
      <div className="container">
        <span className="kicker reveal" style={{ "--d": "0ms" }}>
          FAQ
        </span>

        <h2 className="h2 reveal" style={{ "--d": "90ms" }}>
          Common questions
        </h2>

        <div className="faq mt24">
          {faqs.map((x, i) => (
            <FAQItem
              key={`${x.q}-${i}`}
              q={x.q}
              a={x.a}
              isOpen={open === i}
              onToggle={() => setOpen(open === i ? -1 : i)}
              delay={`${180 + i * 70}ms`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
